import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { InterventionRoomPropertyResponse } from '../../api/generated';
import type { RootState } from '../index';

interface InterventionRoomPropertiesState {
  items: InterventionRoomPropertyResponse[];
}

const initialState: InterventionRoomPropertiesState = {
  items: []
};

const interventionRoomPropertiesSlice = createSlice({
  name: 'interventionRoomProperties',
  initialState,
  reducers: {
    setInterventionRoomProperties: (
      state,
      action: PayloadAction<InterventionRoomPropertyResponse[]>
    ) => {
      state.items = action.payload;
    },
    clearInterventionRoomProperties: (state) => {
      state.items = [];
    }
  }
});

export const { setInterventionRoomProperties, clearInterventionRoomProperties } =
  interventionRoomPropertiesSlice.actions;

export const selectInterventionRoomProperties = (state: RootState) =>
  state.interventionRoomPropertiesSlice.items;

export default interventionRoomPropertiesSlice.reducer;
